export default __webpack_public_path__ + "static/media/bepado.50afdc85.png";